module.exports = __webpack_public_path__ + "img/ng.9d003ecf.svg";